/* eslint-disable max-nested-callbacks */
import { arrayHasLength, flatMap } from '~utils/array';

export const mapCart = (state) => {
  const { cart, orderTaker } = state;

  const cartArray = Array.isArray(cart.cart) ? cart.cart : [];

  const dispatch_method = orderTaker.deliveryType || 'in_store';
  const store_id = parseInt(orderTaker.store, 10);

  const { textAddress, description, apartmentDetails, latitude, longitude, placeId } =
    (dispatch_method === 'in_store' ? orderTaker.storeData : orderTaker.address) || {};

  return {
    shopping_cart: {
      user_name: orderTaker.customer.name,
      user_phone: orderTaker.customer.phone,
      user_address: description && arrayHasLength(description) ? description : textAddress,
      user_city: orderTaker.storeData.commune,
      user_latitude: String(latitude),
      user_longitude: String(longitude),
      apartment_details: apartmentDetails,
      google_place_id: placeId,
      store_id,
      dispatch_method,
      items: cartArray
        .filter(({ addedByCoupon }) => !addedByCoupon)
        .map(({ product, count, items }) => ({
          product_id: product && product.id ? product.id : product.productId ? product.productId : 'noid',
          quantity: count,
          ...(Object.keys(items).length
            ? {
                modifiers: flatMap((key) => {
                  const mods = items[key];
                  if (!Array.isArray(mods)) {
                    return mods && typeof mods === 'object'
                      ? [
                          {
                            id: mods.id,
                            name: mods.name,
                            quantity: mods.quantity,
                            action: 'add',
                            parentId: mods.parentId
                          }
                        ]
                      : [];
                  }
                  return mods.map(({ id, name, quantity, parentId }) => ({
                    id,
                    name,
                    quantity,
                    action: 'add',
                    parentId
                  }));
                }, Object.keys(items))
              }
            : {})
        })),
      requested_time: orderTaker.deliveryTime !== 'now' ? orderTaker.deliveryTime : null,
      loyalty_points: null,
      coupon: orderTaker.coupon || '',
      coupon_payment_method: '',
      tax_free: orderTaker.taxFree || undefined
    }
  };
};
